import {Autocomplete} from '../1elements'
import {useEffect, useState} from 'react'
import ApiService from '../../common/ApiCalls'
import {validateApproverName} from '../../services/util/editChecks'
import {removeSelectedOptions} from '../../services/util/formatter'

const autocompleteSx = {
    padding: 0,
    maxWidth: '400px',
    '& .MuiInputBase-root': {
        padding: 0
    },
    '& .MuiAutocomplete-inputRoot': {
        maxHeight: '29px'
    },
    '& .MuiInputBase-input': {
        height: '10px'
    }
}

const ApproverSearch = ({className, approver, setApprover, showError, selectedUsers, dashboard, locationId}) => {
    const [approverList, setApproverList] = useState([])
    const [searchWord, setSearchWord] = useState('')

    const updateSearchWord = (e) => {
        setSearchWord(e.target.value)
    }

    useEffect(()=>{
            if(dashboard){
                ApiService().searchApprovers(searchWord, locationId)
                    .then((res)=> {
                        const selectedUserRemoved = selectedUsers ? removeSelectedOptions(res, selectedUsers) : res
                        setApproverList(selectedUserRemoved)
                    })
            }else{
                if(searchWord){
                    const keyword = {searchInput: searchWord}
                    ApiService().searchApprover(keyword)
                        .then((res)=> {
                            const selectedUserRemoved = selectedUsers ? removeSelectedOptions(res, selectedUsers) : res
                            setApproverList(selectedUserRemoved)
                        })
                }
            }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [locationId, searchWord])

    useEffect(()=>{
        setApproverList([])
    }, [selectedUsers])

    return (
        <Autocomplete className={className} sx={autocompleteSx} options={approverList}
                      optionLabel={'username'} value={approver} onChangeTextField={updateSearchWord}
                      onChangeAutocomplete={setApprover} validation={validateApproverName(approver)} showError={showError}/>
    )
}

export default ApproverSearch
